import Swiper from 'swiper/bundle';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import videos from '../utils/videos';

gsap.registerPlugin(ScrollTrigger);

const accueil = {
    init() {
        videos.init();
        this.initSwipers();
    },
    initSwipers() {
        const swiper_annonces = new Swiper('.__linkedin', {
            direction: 'horizontal',
            spaceBetween: 50,
            breakpoints: {
                0: {
                    spaceBetween: 20,
                    slidesPerView: 1.1,
                },
                600: {
                    spaceBetween: 30,
                    slidesPerView: 1.4,
                },
                900: {
                    slidesPerView: 2.3,
                },
                1300: {
                    slidesPerView: 2.7,
                }
            }
        });
    },
};

export default accueil;
